// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"129":"MobileLandscape","381":"Chatbot","896":"Modal"}[chunkId] + ".chunk.min.css";
};